import Http from "./httpUtils"
import HttpNew from "./httpUtilsNew"
import {
  REPORT_API,
  AUTH_URL,
  APPID,
  DMP_API,
  AUTH_API,
  COOKIE_DOMAIN,
} from "../constants/conf"
import { Modal } from "antd"
import Cookie from "./cookies"

const SESSION_KEY = "_USER_INSIGHTS_"
var KEY_AUTH = [
  "histoAuth",
  "digitalAuth",
  "tagAuth",
  "gridAuth",
  "trajectoryAuth",
  "positionAuth",
  "aoiProfileAuth",
  "singaporeAuth",
]
var layerType = {
  lvAuth: 4,
  aoiAuth: 5,
  poiAuth: 6,
}
var Auth = {
  isAuthenticated: false,
  user: null,
  auth(user, cb) {
    localStorage.setItem(SESSION_KEY, JSON.stringify(user))
    Auth.isAuthenticated = true
    Auth.user = user
    let menus = user.menus || []
    KEY_AUTH.forEach((k) => {
      if (user[k] && user[k] === "1") {
        user[k] = true
      } else {
        user[k] = false
      }
    })
    for (let k in layerType) {
      if (menus.length && menus.includes(layerType[k])) {
        user[k] = true
      } else {
        user[k] = false
      }
    }

    cb && cb({ error: 0 })
  },
  signout(cb) {
    this.isAuthenticated = false
    this.user = {}
    setTimeout(cb, 100)
  },
  getRedirectUri() {
    return window.location.origin + window.location.pathname + "#/auth"
  },
  goToAuth() {
    // sessionStorage.setItem("__LAST_PATH__", window.location.href)
    window.location.href =
      AUTH_URL +
      "/show?prod=insights&template=2&response_type=code&state=wayz&client_id=" +
      APPID +
      "&redirect_uri=" +
      encodeURIComponent(this.getRedirectUri())
  },
}
let cookie = null
export default {
  setDataAuth(groups, sources) {
    Auth.user.groups = groups
    Auth.user.sources = sources
    Auth.user.sids = sources.map((s) => {
      return s.id
    })
  },
  setMenusAuth(menus) {
    Auth.user.menus = menus
  },
  getMenus: function (token, cb) {
    HttpNew.request({
      method: "get",
      url: AUTH_API + "/insights/oauth/v1/user/authority",
      params: {},
      headers: { token: token },
    })
      .then((res) => {
        let menus = []
        if (res.code === 0) {
          let list = res.data || []
          menus = list.map((el) => {
            return el.id
          })
        }
        cb(menus)
      })
      .catch((e) => {
        Modal.error({
          title: "提示",
          content: "您暂无访问权限！",
          onOk: function (params) {
            Auth.goToAuth()
          },
        })
      })
  },

  isLogin() {
    return Auth.isAuthenticated
  },
  getCookie() {
    if (!cookie) {
      cookie = Cookie.parsedCookies()
    }
    return cookie
  },
  loginCloud() {
    window.location.href = `https://cloud.newayz.com/passport/#/login?redirect=${encodeURIComponent(
      window.location.href
    )}`
  },
  /**
   * 退出
   * @param {*} cb
   */
  logout(cb) {
    Http.post(REPORT_API + "/v1/api/logout", {
      _headers: { token: Auth.user.token, Authorization: Auth.user.jtoken },
    })
      .done((res) => {
        if (res.code === 1) {
          Auth.isAuthenticated = false
          localStorage.removeItem(SESSION_KEY)
          Auth.goToAuth()
          // Cookie.removeItem('user', '/', COOKIE_DOMAIN)
        } else {
          // alert(res.msg)
        }
      })
      .fail((err) => {
        localStorage.removeItem(SESSION_KEY)
        Auth.goToAuth()
      })
  },
  requestUserInfo: function (cb) {
    let that = this
    if (Auth.isAuthenticated) {
      cb()
      return
    }
    if (window.location.hash.indexOf("#/auth") === 0) {
      cb()
      return
    }
    let user = localStorage.getItem(SESSION_KEY)
    // user = JSON.parse(user)
    // if (!user || !user.dmpToken) {
    //   Auth.goToAuth()
    //   return
    // }
    if (!user) {
      Auth.goToAuth()
      return
    }
    try {
      user = JSON.parse(user)
      if (user.dmpToken && user.expires > +new Date()) {
        that.getMenus(user.dmpToken, (menus) => {
          user.menus = menus
          Auth.auth(user)
          cb()
          return
        })
      } else {
        Auth.goToAuth()
      }
    } catch (e) {
      Auth.goToAuth()
    }
  },
  getUser: function () {
    if (!Auth.user) {
      this.requestUserInfo(() => {})
    }
    return Auth.user || {}
  },
  /**
   * 用code去换取token
   */
  authCode: function (code, cb) {
    let that = this
    if (!code) {
      Auth.goToAuth()
    } else {
      Http.get(REPORT_API + "/v1/api/callback", {
        code: code,
        redirectUri: encodeURIComponent(Auth.getRedirectUri()),
      })
        .done(function (res) {
          let user = res.data
          if (res.code === 0 && user && user.token) {
            Http.get(AUTH_URL + "/oauth2/get_kong_token", {
              access_token: user.token,
            }).done((res) => {
              let data = res.data
              if (res.code === 0) {
                Http.request({
                  method: "get",
                  url: DMP_API + "/cloud/get_token",
                  headers: {
                    appid: "gOlNihZLeST6LdgEJIBSlL5oXA",
                    appsecret: "kQikMzQnV1om4ubNwk2rpvlXFj0",
                    username: user.username,
                  },
                })
                  .done((res) => {
                    let d = res.data || {}
                    user.jtoken = "Bearer " + data.kong_token
                    user.expires = data.expires_in * 1000
                    user.dmpToken = d.access_token
                    user.user_type = d.user_type
                    //获取当前用户菜单权限
                    that.getMenus(d.access_token, (menus) => {
                      user.menus = menus
                      Auth.auth(user, cb)
                    })
                  })
                  .fail((res) => {
                    user.jtoken = "Bearer " + data.kong_token
                    user.expires = data.expires_in * 1000
                    Auth.auth(user, cb)
                  })
              }
            })
            // Auth.auth(user, cb)
          } else {
            Modal.error({
              title: "提示",
              content: "您暂无访问权限！",
              onOk: function (params) {
                Auth.goToAuth()
              },
            })
            // alert(res.msg)
          }
        })
        .fail((e) => {
          // Auth.goToAuth()
        })
    }
  },
}
